import React, { useState, useEffect, useMemo } from 'react';
import { deleteBd } from '../../config/functions';
import { showNotification } from '../utils/NotificationFooter';
import { showConfirmDialog } from '../utils/ConfirmDialog';
import ModalVariableConfigOpt from '../liveDataOpt/ModalVariableConfigOpt';
import '../../css/grillaIzqOpt.css';

const THEME_LIGHT = {
    bgColor: '#f5f5f5',
    fontColor: '#000000',
    cardBgColor: '#ffffff',
    cardBorderColor: '#cccccc',
    measureColor: '#0066cc',
    alarmColor: '#ff0000'
};

export const GrillaIzqOpt = ({ 
    rig, 
    user, 
    uid, 
    colors, 
    mobile,
    datosIzquierda = Array(6).fill(''), // Datos completos desde LiveGraphsOptimized
    variablesIzquierda = Array(6).fill('0'), // IDs de variables desde LiveGraphsOptimized
    isVisible = true, // Controlado por el padre
    onToggleVisibility, // Callback para toggle
    variables = [], // Lista completa de variables disponibles (para selección)
    onReloadPlantilla, // Callback para recargar plantilla después de cambios CRUD
    theme: externalTheme, // Tema desde el padre (LiveGraphsOptimized)
    themeMode: externalThemeMode // Modo de tema desde el padre
}) => {
    // States locales (solo UI) - isVisible ahora viene del padre
    
    // Modal states - Unificado para ModalVariableConfigOpt
    const [showModalConfig, setShowModalConfig] = useState(false);
    const [modalInitialTab, setModalInitialTab] = useState('variable');
    const [currentModalVariable, setCurrentModalVariable] = useState(null);
    const [currentPosition, setCurrentPosition] = useState(0);
    const [updateVarMatrizId, setUpdateVarMatrizId] = useState(0);
    
    // Theme integration - Usar tema externo si está disponible, sino calcular localmente
    const theme = useMemo(() => {
        // Si el padre pasa el tema, usarlo directamente
        if (externalTheme) {
            //console.log('🎨 GrillaIzqOpt - Usando tema del padre:', externalThemeMode);
            return externalTheme;
        }
        
        // Fallback: calcular tema localmente (por si acaso)
        const currentTheme = localStorage.getItem('theme') || 'dark';
        
        if (currentTheme === 'light') {
            return THEME_LIGHT;
        }
        
        // Dark or custom theme - use colors from props
        return {
            bgColor: colors.grColorBg || '#1a1a1a',
            fontColor: colors.grColorFont || '#ffffff',
            cardBgColor: colors.grColorBg || '#1a1a1a',
            cardBorderColor: colors.grColorBorder || '#333333',
            measureColor: colors.grColorMeasure || '#00ff00',
            alarmColor: colors.grColorAlarm || '#ff0000'
        };
    }, [externalTheme, externalThemeMode, colors]);

    // Update CSS variables for theme
    useEffect(() => {
        document.documentElement.style.setProperty('--color-default', theme.fontColor);
        document.documentElement.style.setProperty('--color-measure', theme.measureColor);
        document.documentElement.style.setProperty('--color-alarm', theme.alarmColor);
    }, [theme]);

    // Ya no necesitamos listener de eventos porque el tema viene como prop del padre
    // El componente se re-renderizará automáticamente cuando cambie externalTheme

    // TODO: Funciones CRUD se implementarán para actualizar BD y notificar al padre
    // Por ahora GrillaIzqOpt solo renderiza datos que recibe como props

    /* ELIMINADO - Ahora el padre (LiveGraphsOptimized) maneja la carga de plantilla
    useEffect(() => {
        if (!rig || mobile) return;

        const loadPlantilla = async () => {
            try {
                const data = await getTableByIdBd(rig + ':' + user, 'getvarsalarmgraphizq');
                if (data && data.length > 0) {
                    setPlantillaIzq(data);
                    console.log('🟢 GrillaIzqOpt - Plantilla cargada:', data.length, 'variables');
                }
            } catch (error) {
                console.error('❌ Error cargando plantilla:', error);
            }
        };

        loadPlantilla();
    }, [rig, mobile, user]);

    // Organize variables by order - Solo al cargar plantilla inicial
    useEffect(() => {
        if (!plantillaIzq || plantillaIzq.length === 0) return;

        const ordenVariables = Array(6).fill('0');
        const datosOrdenados = Array(6).fill('');

        plantillaIzq.forEach((item) => {
            const orden = item.nb_datos_grafica_orden;
            if (orden >= 0 && orden < 6) {
                ordenVariables[orden] = item.nb_var_idn;
                datosOrdenados[orden] = item;
            }
        });

        setVariablesIzquierda(ordenVariables);
        setDatosIzquierda(datosOrdenados);
        
        // Notificar al padre (LiveGraphsOptimized) que cambiaron las variables
        console.log('📤 GrillaIzqOpt - Intentando notificar variables:', {
            ordenVariables,
            hasCallback: !!onVariablesIzquierdaChange,
            callbackType: typeof onVariablesIzquierdaChange
        });
        
        if (onVariablesIzquierdaChange) {
            onVariablesIzquierdaChange(ordenVariables);
            console.log('✅ GrillaIzqOpt - Variables notificadas correctamente');
        } else {
            console.warn('⚠️ GrillaIzqOpt - No hay callback onVariablesIzquierdaChange');
        }
    }, [plantillaIzq, onVariablesIzquierdaChange]);

    // 🔄 Actualizar valores cuando medidasGraficas cambia (polling cada 10s)
    useEffect(() => {
        if (medidasGraficas.length === 0 || datosIzquierda.every(d => d === '')) return;

        // Actualizar datosIzquierda con los últimos valores de medidasGraficas
        const datosActualizados = datosIzquierda.map(dato => {
            if (!dato || dato === '' || !dato.nb_var_idn) return dato;

            console.log(dato)
            // Buscar el último valor de esta variable en medidasGraficas
            const liveData = medidasGraficas
                .filter(item => parseInt(item.nb_var_idn) === parseInt(dato.nb_var_idn))
                .sort((a, b) => new Date(b.dt_mda_fch).getTime() - new Date(a.dt_mda_fch).getTime())[0];

            if (liveData) {
                return {
                    ...dato,
                    nb_mda_val: liveData.nb_mda_val,
                    dt_mda_fch: liveData.dt_mda_fch
                };
            }

            return dato;
        });

        setDatosIzquierda(datosActualizados);
    }, [medidasGraficas]); 
    FIN DE CÓDIGO ELIMINADO */

    // ========== FUNCIONES PARA MODAL OPTIMIZADO ==========
    
    // Abrir modal para agregar variable
    const handleAddVariable = (position) => {
        setCurrentPosition(position);
        setUpdateVarMatrizId(0);
        setCurrentModalVariable(null);
        setModalInitialTab('variable');
        setShowModalConfig(true);
    };

    // Abrir modal para cambiar variable
    const handleChangeVariable = (dato, position) => {
        setCurrentPosition(position);
        setUpdateVarMatrizId(dato.nb_datos_grafica_idn);
        setCurrentModalVariable({
            vr_var_nom: dato.vr_var_nom,
            nb_var_idn: dato.nb_var_idn,
            nb_alarm_min: dato.nb_alarm_min,
            nb_alarm_max: dato.nb_alarm_max,
            nb_alarm_idn: dato.nb_alarm_idn
        });
        setModalInitialTab('variable');
        setShowModalConfig(true);
    };

    // Abrir modal para configurar alarma
    const handleConfigureAlarm = (dato) => {
        setUpdateVarMatrizId(dato.nb_datos_grafica_idn);
        setCurrentModalVariable({
            vr_var_nom: dato.vr_var_nom,
            nb_var_idn: dato.nb_var_idn,
            nb_alarm_min: dato.nb_alarm_min,
            nb_alarm_max: dato.nb_alarm_max,
            nb_alarm_idn: dato.nb_alarm_idn
        });
        setModalInitialTab('alarm');
        setShowModalConfig(true);
    };

    // Handler para actualización (recarga plantilla)
    const handleModalUpdate = async () => {
        if (onReloadPlantilla) {
            await onReloadPlantilla();
        }
    };

    // Delete variable from matrix
    const deleteVarMatrizIzq = async (id, posi) => {
        showConfirmDialog(
            '¿Está seguro de eliminar esta variable?',
            async () => {
                try {
                    await deleteBd(id, 'deletevarmatrizizq');
                    showNotification('Variable eliminada correctamente', 'success');
                    
                    // Notificar al padre para recargar plantilla
                    if (onReloadPlantilla) {
                        await onReloadPlantilla();
                    }
                } catch (error) {
                    console.error('Error al eliminar variable:', error);
                    showNotification('Error al eliminar variable', 'error');
                }
            },
            () => {
                console.log('Eliminación cancelada');
            }
        );
    };

    // Render single variable slot
    const renderDato = (dato) => {
        // datosIzquierda ya tiene los valores actualizados del useEffect
        const d = datosIzquierda[dato];
        const nbAlarmMax = parseFloat(d?.nb_alarm_max)?.toFixed(2) || 0;
        const nbMdaVal = parseFloat(d?.nb_mda_val)?.toFixed(2);
        const nbAlarmMin = parseFloat(d?.nb_alarm_min)?.toFixed(2);
        const hasValidData = d && d !== '' && !isNaN(d.nb_mda_val);

        return (
            <div className="grilla-izq-slot" key={dato}>
                <div 
                    className="grilla-izq-card"
                    style={{
                        backgroundColor: theme.cardBgColor,
                        borderColor: theme.cardBorderColor,
                        color: theme.fontColor
                    }}
                >
                    {hasValidData ? (
                        <>
                            {/* Header with variable name and delete button */}
                            <div className="grilla-izq-header">
                                <h6 
                                    className="grilla-izq-title"
                                    title={d.vr_var_nom + ' - Cambiar Variable'}
                                    onClick={() => handleChangeVariable(d, dato)}
                                >
                                    {d.vr_var_nom}
                                </h6>
                                <span
                                    className="grilla-izq-delete"
                                    title="Eliminar variable"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        deleteVarMatrizIzq(d.nb_datos_grafica_idn, dato);
                                    }}
                                >
                                    <i className="fa fa-times"></i>
                                </span>
                            </div>

                            {/* Value with alarm status */}
                            <h4 
                                className={
                                    nbAlarmMax >= 0
                                        ? (nbMdaVal >= nbAlarmMin && nbMdaVal <= nbAlarmMax)
                                            ? "grilla-izq-value alarm-ok"
                                            : "grilla-izq-value alarm-active"
                                        : "grilla-izq-value alarm-ok"
                                }
                                title="Clic para configurar alarma"
                                data-var-izq-id={d.nb_var_idn}
                                onClick={() => handleConfigureAlarm(d)}
                            >
                                {d.vr_var_umd === 'no/yes'
                                    ? d.nb_mda_val === '0' ? 'NO' : 'YES'
                                    : parseFloat(parseFloat(d.nb_mda_val) - parseInt(parseFloat(d.nb_mda_val))).toFixed(2) > 0
                                        ? parseFloat(d.nb_mda_val).toFixed(2)
                                        : parseFloat(d.nb_mda_val).toFixed(0)
                                }
                            </h4>

                            {/* Unit */}
                            <p className="grilla-izq-unit">{d.vr_var_umd}</p>
                        </>
                    ) : (
                        <>
                            {/* Empty slot - add variable */}
                            <h6 className="grilla-izq-empty-title">Seleccionar</h6>
                            <button 
                                className='grilla-izq-add-btn'
                                onClick={() => handleAddVariable(dato)}
                            >
                                <i className="fa-solid fa-plus"></i>
                            </button>
                        </>
                    )}
                </div>
            </div>
        );
    };

    // Toggle visibility - ahora usa el callback del padre
    const handleToggleVisibility = () => {
        if (onToggleVisibility) {
            onToggleVisibility();
        }
    };

    if (!rig || mobile) return null;

    return (
        <>
            {isVisible ? (
                <div 
                    className="grilla-izq-container"
                    style={{
                        backgroundColor: theme.bgColor
                    }}
                >
                    {/* Toggle button arriba */}
                    <div className="grilla-izq-toggle-header">
                        <button 
                            className="grilla-izq-toggle-btn"
                            onClick={handleToggleVisibility}
                            title="Ocultar Panel"
                            style={{
                                backgroundColor: theme.cardBgColor,
                                color: theme.fontColor,
                                borderColor: theme.cardBorderColor
                            }}
                        >
                            <i className="fa fa-chevron-left"></i>
                        </button>
                    </div>

                    {/* Variables */}
                    {renderDato(0)}
                    {renderDato(1)}
                    {renderDato(2)}
                    {renderDato(3)}
                    {renderDato(4)}
                    {renderDato(5)}
                </div>
            ) : (
                <div className="grilla-izq-toggle-collapsed">
                    <button 
                        className="grilla-izq-toggle-btn"
                        onClick={handleToggleVisibility}
                        title="Mostrar Panel"
                        style={{
                            backgroundColor: theme.cardBgColor,
                            color: theme.fontColor,
                            borderColor: theme.cardBorderColor
                        }}
                    >
                        <i className="fa fa-chevron-right"></i>
                    </button>
                </div>
            )}

            <ModalVariableConfigOpt
                show={showModalConfig}
                handleClose={() => setShowModalConfig(false)}
                rig={rig}
                currentVariable={currentModalVariable}
                variables={variables}
                updateVarMatrizId={updateVarMatrizId}
                uid={uid}
                user={user}
                onUpdate={handleModalUpdate}
                initialTab={modalInitialTab}
                theme={theme}
                gridType="izquierda"
                position={currentPosition}
            />
        </>
    );
};
